import BaseClass from "./BaseClass";

export default class SharedCustomersWidgets extends BaseClass {
  get schema() {
    return {
      name: {},
      email: {},
      is_admin: { type: Boolean },
      active: { type: Boolean }
    };
  }
}
